import { useEffect } from 'react'
import { history } from 'ui/customHooks/useHistory'
import {
  PageEventType,
  triggerAnalytics,
  triggerAnalyticsEvent
} from 'helpers/analytics'

export const useAnalyticsOnLoad = ({
  subFunction = '',
  name = 'start',
  pageFunction = '',
  message = '',
  isUpdated = true,
  ...rest
}: PageEventType): void => {
  const onPageLoad = (): void => {
    const analyticsPayload = {
      subFunction,
      name,
      pageFunction,
      message,
      pathName: history.location.pathname,
      ...rest
    }
    if (pageFunction === '') {
      delete analyticsPayload.pageFunction
    }
    if (isUpdated) {
      triggerAnalyticsEvent(analyticsPayload)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(onPageLoad, [isUpdated])
}

export const useAnalyticsOnComplete = (
  isCompleted = false,
  subFunction = '',
  pageFunction = ''
): void => {
  const onComplete = (): void => {
    if (isCompleted) {
      triggerAnalytics('complete', subFunction, pageFunction)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(onComplete, [isCompleted])
}
